export default __webpack_public_path__ + "static/media/step-type-email.339f1593.svg";